import { Errors } from '../../shared/errors';
import type { Field, MhElement, PublicConfig, WidgetConfig } from '../../shared/interfaces';
import * as fields from '../@fields';

const createFeedbackElement = (input: HTMLInputElement | HTMLSelectElement) => {
    const feedback = document.createElement(`p`);
    feedback.style.color = `red`;
    feedback.style.fontSize = `0.75rem`;
    feedback.innerHTML = `&nbsp;`;
    input.parentNode?.insertBefore(feedback, input.nextSibling);
    return feedback;
};

const defaultField: Field = {
    feedback: true,
};

export const setupElements = async (
    elements: Record<string, MhElement>,
    publicConfig: PublicConfig,
    widgetConfig: WidgetConfig,
    form: HTMLFormElement,
) => {
    const errors: string[] = [];

    const mutating = Object.entries(elements).map(async ([fieldName, element]) => {
        if (element.input && element.input.type === `hidden`) {
            return;
        }

        const field: Field = (fields as any)[fieldName.replaceAll(` `, `_`)] ?? defaultField;
        await field.mutate?.(element, elements, publicConfig, widgetConfig, form).catch((err: Error) => {
            errors.push(err.message);
        });

        if (field.feedback) {
            if (!element.input) {
                errors.push(`Field "${fieldName}" does not have input.`);
                return;
            }

            element.feedback = createFeedbackElement(element.input);
        }

        field.setupValidation?.(element);
    });

    await Promise.all(mutating);

    if (errors.length > 0) {
        throw new Errors(errors);
    }
};
